import React from 'react';
import { useLocale } from '../locale/LanguageProviderV2';

export default ({ onContactClick }) => {
  const { t } = useLocale();
  return (
    <footer className="main-footer" id="main-footer">
      <div className="support">
        <div className="inner">
          <a
            className="icon-info2 footer-link cursor-pointer"
            href={t('footer_aboutCreditinfo_link')}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('footer_aboutCreditinfo')}
          </a>
          {onContactClick ? (
            <span className="icon-envelope footer-link cursor-pointer" onClick={onContactClick}>
              {t('footer_contactUs')}
            </span>
          ) : (
            <a
              href="mailto:creditinfo@creditinfo.is"
              className="icon-envelope footer-link cursor-pointer"
              rel="noopener noreferrer"
            >
              {t('footer_contactUs')}
            </a>
          )}
        </div>
      </div>
    </footer>
  );
};
